<template>
  <div class="activity-guide-box">
    <div class="title">欢迎加入明明城堡</div>
    <img class="check_img" :src="require('@/assets/images/check.png')" />
    <div class="tip_text">已获得《古诗词》全部课程</div>
    <div class="tip_text">关注公众号【明明城堡】可接收上课提醒</div>
    <img class="follow_img" :src="require('@/assets/images/follow.png')" />
    <div class="start_btn" @click="navToClass">立即看动画学古诗词</div>
    <ServiceStick />
  </div>
</template>

<script>
import ServiceStick from '@/components/ServiceStick'
export default {
  name: 'activityPoemGuide',
  data() {
    return {
      id: -1,
      showServicePopup: false
    }
  },
  components: {
    ServiceStick
  },
  async mounted() {
    await this.weixinAuth()
    console.log('古诗词领取成功页面')
    const { id } = this.$route.query
    if (id) {
      this.id = id
      console.log(`page: activity/guide。参数id:${id}`)
    } else {
      console.error('page: activity/guide。进入页无参数id')
    }
  },
  methods: {
    navToClass() {
      if (this.id > -1) {
        this.$router.push({
          name: 'learn',
          query: { id: this.id }
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.activity-guide-box {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .title {
    text-align: center;
    margin-top: 30px;
    font-size: 18px;
  }

  .check_img {
    margin-top: 30px;
    margin-bottom: 20px;
    width: 60px;
  }

  .tip_text {
    margin-top: 10px;
    color: #FF563E;
    font-size: 14px;
  }

  .follow_img {
    margin-top: 20px;
    width: 80%;
  }

  .start_btn {
    width: 80%;
    margin-top: 20px;
    color: #FF563E;
    font-size: 14px;
    border-color: #FF563E;
    border-width: 1px;
    border-style: solid;
    border-radius: 20px;
    padding-top: 10px;
    padding-bottom: 10px;
    text-align: center;
  }

  .guide_img {
    width: 60px;
    position: fixed;
    bottom: 20%;
    right: 0px;
  }
}
</style>
